module.exports = __webpack_public_path__ + "banquet/components/ShoppingCartPopover/images/nav_bag.3c2b63e77b999e8b7173bfc0679e9cca.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/ShoppingCartPopover/images/nav_bag.png
// module id = 1686
// module chunks = 1